import React from 'react';
import BasicResource from "../cmsbase/BasicResource";
import {demoFormFields, demoListFields} from "../../network/mockData";

function Groups(props) {
    return (
        <BasicResource
            dataUrl="mock/digitalsignage/groups"
            entityUrl="mock/digitalsignage/group"
            submitUrl={"TODO-submit-url"}
            tableFields={demoListFields}
            formFields={demoFormFields}

        />
    );
}

export default Groups;